import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { Toggle } from '@daedalus/atlas/Toggle';
import { Tooltip, TooltipPlacement } from '@daedalus/atlas/Tooltip';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const _exp = /*#__PURE__*/() => Flex.Row;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "wfmttxo",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Flex.Row;
const LabelWrapper = /*#__PURE__*/styled(_exp2())({
  name: "LabelWrapper",
  class: "lttk8fl",
  propsAsIs: true
});
interface Props {
  checked: boolean;
  onChange: () => void;
  totalPriceMessage: React.ReactNode;
}
export const TotalPriceToggleDesktop: React.FC<Props> = ({
  checked,
  onChange,
  totalPriceMessage
}) => {
  return <Wrapper gap="s200">
      <LabelWrapper alignItems="center" gap="s100" onClick={onChange}>
        <Text variant="bodyS" id="showTotalPrice">
          <FormattedMessageWrapper id="showTotalPrice" defaultMessage="Show total price" />
        </Text>
        <Tooltip placement={TooltipPlacement.BottomStart} content={<Text variant="bodyS">{totalPriceMessage}</Text>}>
          <Icon name="Information" size={'sm'} colorPath="content.neutral.c600" />
        </Tooltip>
      </LabelWrapper>
      <Toggle id="totalPriceToggle" checked={checked} onChange={onChange} ariaLabelledBy="showTotalPrice" />
    </Wrapper>;
};

require("./TotalPriceToggleDesktop.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./TotalPriceToggleDesktop.tsx");